import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Lock from '../../assets/Security_lock.svg';
import { attachClickOffHandler } from '../../utils/page-utils';
import styles from './MessageCenterFooter.module.scss';

const cx = classNames.bind(styles);

const MessageCenterFooter = ({
  leftText = 'Please be advised that financial transactions cannot be handled by email.'
}) => {
  const [showTip, toggleTip] = useState(false);

  const toggleTipWithClickOff = e => {
    toggleTip(!showTip);
    attachClickOffHandler('tip', () => toggleTip(showTip), e);
  };
  return (
    <div className={styles['footer-container']} id="message-center-footer">
      <span className={styles.text}>{leftText}</span>
      <div className={styles.right}>
        <p className={cx('text', 'desktop-only', 'nowrap')}>
          Secure Messaging System
        </p>
        {showTip && (
          <div
            className={cx('text', 'tip', 'mobile-only') + ' tip'}
            id="secure-tooltip"
          >
            Secure Messaging System
          </div>
        )}
        <img
          alt="lock"
          className={styles.img}
          id="lock-icon"
          onClick={e => toggleTipWithClickOff(e)}
          src={Lock}
        />
      </div>
    </div>
  );
};

MessageCenterFooter.propTypes = {
  leftText: PropTypes.node
};

export default MessageCenterFooter;
